import { Controller } from "@hotwired/stimulus"

const CATEGORIES = {
  "All Art": [],
  Paintings: ["oil", "acrylic", "watercolour", "ink", "gouache", "mixed-media", "airbrush", "spray-paint", "stencil", "resin"],
  Photography: ["photograph"],
  Drawings: ["pencil", "ink", "pastel", "drawing", "charcoal"],
  Sculpture: ["sculpture", "ceramic", "bronze", "metal", "fibre", "glass", "wood", "weaving"],
  Printmaking: ["lithograph", "linocut-print", "screenprinting", "giclee", "etching", "woodcut", "engraving", "reproduction-print", "collagraph", "monotype"],
  Digital: ["digital"],
  "Other media": ["other-media"],
}

export default class extends Controller {
  static targets = ["sort", "category", "per"]

  sortChanged() {
    const radio = document.querySelector(`input[type="radio"][name="sort"][value="${this.sortTarget.value}"]`)
    if (!radio) return

    radio.checked = true
    radio.dispatchEvent(new Event("change", { bubbles: true }))
  }

  perChanged() {
    const radio = document.querySelector(`input[type="radio"][name="per"][value="${this.perTarget.value}"]`)
    if (!radio) return

    radio.checked = true
    radio.dispatchEvent(new Event("change", { bubbles: true }))
  }

  categoryChanged() {
    const selectedMediums = CATEGORIES[this.categoryTarget.value] || []
    const checkboxes = document.querySelectorAll('input[type="checkbox"][name="medium[]"]')
    if (!checkboxes.length) return

    checkboxes.forEach((cb) => {
      cb.checked = selectedMediums.includes(cb.value)
      const img = cb.closest("label")?.querySelector("img[data-checked-src]")
      if (img) img.src = cb.checked ? img.dataset.checkedSrc : img.dataset.uncheckedSrc
    })

    checkboxes[0].dispatchEvent(new Event("change", { bubbles: true }))
  }
}
